import styled from 'styled-components';
import { themeGet } from 'styled-system';

const TestimonialSectionWrapper = styled.section`
  overflow: hidden;
  padding: 100px 0;
  .glide {
    max-width: 954px;
    margin: 0 auto;
    .glide__slide {
      display: flex;
      margin-bottom: 40px;
      @media only screen and (max-width: 991px) {
        padding-top: 30px;
      }
      @media only screen and (max-width: 680px) {
        flex-direction: column-reverse;
      }
    }
    .glide__controls {
      position: relative;
      bottom: 0;
      .reusecore__button {
        &:hover {
          color: ${themeGet('colors.quoteText', '#343d48')};
        }
      }
    }
  }
`;

const TextWrapper = styled.div`
  margin-right: auto;
  position: relative;
  padding-left: 12px;
  margin-right: 30px;
  min-width: calc(100% - 230px);

  p {
    text-indent: 27px;
    margin-bottom: 25px;
  }

  i {
    color: rgba(52, 61, 72, 0.2);
    font-size: 20px;
    position: absolute;
    top: 0;
    left: 12px;
    z-index: -1;
  }
`;

const ImageWrapper = styled.div`
  width: 200px;
  height: 200px;
  position: relative;
  @media only screen and (max-width: 680px) {
    margin:0 auto 40px;
  }
  .reusecore__button {
    position: absolute;
    z-index: 2;
    bottom: 0;
    left: 20px;
    width: 65px;
    height: 65px;
    font-size: 26px;
    background-color: rgb(220, 57, 95);
    box-shadow: 0px 10px 28.2px 1.8px rgba(23, 65, 104, 0.2);
  }
`;

const RoundWrapper = styled.div`
  width: 200px;
  height: 200px;
  border-radius: 50%;
  box-sizing: border-box;
  border-bottom-right-radius: 10px;
  background: ${props => props.gradient};
  overflow: hidden;
  display: flex;
  img {
    max-width: 60%;
    width: 220px;
    margin: auto;
  }
`;

const ClientName = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 575px) {
    flex-direction: column;
    align-items: inherit;
  }
`;

export { TextWrapper, ImageWrapper, ClientName, RoundWrapper };

export default TestimonialSectionWrapper;
